import React from 'react';
import { formatDollar } from '../../../helpers/utils';
const Row = ({
  location,
  own,
  accent_color,
  display_dollar_amount,
  display_ticket_quantity
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "location"
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, location.ranking, "."), " ", location.location)), /*#__PURE__*/React.createElement(React.Fragment, null, display_dollar_amount && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "previous-sales"
  }, location.previous_sales ? formatDollar(location.previous_sales) : '-'), /*#__PURE__*/React.createElement("div", {
    className: "current-sales"
  }, location.sales ? formatDollar(location.sales) : '-')), location.sales && /*#__PURE__*/React.createElement("div", {
    className: "variance-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: `variance variance-arrow ${location.variation >= 0 ? 'positive' : 'negative'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `arrow ${location.variation >= 0 ? 'up' : 'down'}`
  })), /*#__PURE__*/React.createElement("div", {
    className: `variance ${location.variation >= 0 ? 'positive' : 'negative'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("b", null, location.variation > 0 ? `+${Math.round(location.variation)}` : Math.round(location.variation), "%")))), display_ticket_quantity && /*#__PURE__*/React.createElement("div", {
    className: "ticket-quantity"
  }, location.ticket_quantity ? /*#__PURE__*/React.createElement("div", null, location.ticket_quantity) : '-')));
};
export default Row;